module.exports = __webpack_public_path__ + "static/media/checkout-tomford.eab95d77.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/winter-2019/checkout-tomford.png
// module id = 154
// module chunks = 0